var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcChipDivision(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 3H4.5C4.22386 3 4 3.22386 4 3.5V4.5C4 4.77614 4.22386 5 4.5 5H5.5C5.77614 5 6 4.77614 6 4.5V3.5C6 3.22386 5.77614 3 5.5 3Z",
    fill: "#6C5CE7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 3H8.5C8.22386 3 8 3.22386 8 3.5V4.5C8 4.77614 8.22386 5 8.5 5H9.5C9.77614 5 10 4.77614 10 4.5V3.5C10 3.22386 9.77614 3 9.5 3Z",
    fill: "#6C5CE7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 6.5H4.5C4.22386 6.5 4 6.72386 4 7V8C4 8.27614 4.22386 8.5 4.5 8.5H5.5C5.77614 8.5 6 8.27614 6 8V7C6 6.72386 5.77614 6.5 5.5 6.5Z",
    fill: "#6C5CE7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 6.5H8.5C8.22386 6.5 8 6.72386 8 7V8C8 8.27614 8.22386 8.5 8.5 8.5H9.5C9.77614 8.5 10 8.27614 10 8V7C10 6.72386 9.77614 6.5 9.5 6.5Z",
    fill: "#6C5CE7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 10H4.5C4.22386 10 4 10.2239 4 10.5V11.5C4 11.7761 4.22386 12 4.5 12H5.5C5.77614 12 6 11.7761 6 11.5V10.5C6 10.2239 5.77614 10 5.5 10Z",
    fill: "#6C5CE7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10H8.5C8.22386 10 8 10.2239 8 10.5V11.5C8 11.7761 8.22386 12 8.5 12H9.5C9.77614 12 10 11.7761 10 11.5V10.5C10 10.2239 9.77614 10 9.5 10Z",
    fill: "#6C5CE7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 16.25H12.75V1C12.7474 0.801893 12.6676 0.612629 12.5275 0.472534C12.3874 0.332439 12.1981 0.25259 12 0.25H2C1.80189 0.25259 1.61263 0.332439 1.47253 0.472534C1.33244 0.612629 1.25259 0.801893 1.25 1V16.25H0.75C0.551088 16.25 0.360322 16.329 0.21967 16.4697C0.0790175 16.6103 0 16.8011 0 17C0 17.1989 0.0790175 17.3897 0.21967 17.5303C0.360322 17.671 0.551088 17.75 0.75 17.75H13.25C13.4489 17.75 13.6397 17.671 13.7803 17.5303C13.921 17.3897 14 17.1989 14 17C14 16.8011 13.921 16.6103 13.7803 16.4697C13.6397 16.329 13.4489 16.25 13.25 16.25ZM11.25 16.25H6V14C6 13.8674 5.94732 13.7402 5.85355 13.6464C5.75979 13.5527 5.63261 13.5 5.5 13.5H4.5C4.36739 13.5 4.24021 13.5527 4.14645 13.6464C4.05268 13.7402 4 13.8674 4 14V16.25H2.75V1.75H11.25V16.25Z",
    fill: "#6C5CE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChipDivision);
export default __webpack_public_path__ + "static/media/ic_chip_division.e3933c773d8992255e9b9feb09a6b9d5.svg";
export { ForwardRef as ReactComponent };